module.exports = __webpack_public_path__ + "media/retinus-pvp-demo-video8.cacb5abd.mp4";